// import { useMutation } from "react-query";
// import axios from "axios";
// import { message } from "antd";

// interface Props {
//   email: string;
// }

// const apiClient = axios.create({
//   baseURL: process.env.REACT_APP_BASE_URL,
// });

// export const useResetStudentPassword = (setStep: any) => {
//   return useMutation(
//     (payload: Props) =>
//       apiClient.post("/auth/reset-password", payload).then((res) => res.data),
//     {
//       onSuccess: () => {
//         setStep(1);
//         message.success("An OTP has been sent to your email");
//       },
//       onError: (error: any) => {
//         message.error(
//           error?.response?.data?.message || "Reset failed. Please try again."
//         );
//       },
//     }
//   );
// };

import { useMutation } from "react-query";
import { message } from "antd";

interface Props {
  email: string;
}

const baseURL = process.env.REACT_APP_BASE_URL;

export const useResetStudentPassword = (setStep: any) => {
  return useMutation(
    async (payload: Props) => {
      const response = await fetch(
        "https://api.w2st.net/api/v1/auth/reset-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        // eslint-disable-next-line no-throw-literal
        throw {
          message: data?.message || "Reset failed.",
          status: response.status,
        };
      }

      return data;
    },
    {
      onSuccess: () => {
        setStep(1);
        message.success("An OTP has been sent to your email");
      },
      onError: (error: any) => {
        message.error(error?.message || "Reset failed. Please try again.");
      },
    }
  );
};
